package tta.destinigo.talktoastro.feature_call_consultation.domain.mapper

import tta.destinigo.talktoastro.feature_call_consultation.data.response.queue_status.BeforeUser
import tta.destinigo.talktoastro.feature_call_consultation.data.response.queue_status.CurrentUser
import tta.destinigo.talktoastro.feature_call_consultation.data.response.queue_status.QueueStatusData
import tta.destinigo.talktoastro.feature_call_consultation.domain.model.QueueStatusUiData
import tta.destinigo.talktoastro.feature_call_consultation.persentation.queue_status_bottomsheet.QueueUser

fun QueueStatusData.toQueueStatusUiData(): QueueStatusUiData = QueueStatusUiData(
    channelName = channelName,
    eventKey = eventName,
    inactiveUserText = if (inactiveUserCount?.coerceAtLeast(0) == 0) "You are Next in Queue" else inactiveUserCount.toString(),
    user = getUser(currentUser,beforeUsers)

)

fun getUser(currentUser: CurrentUser?,beforeUser: List<BeforeUser>?):List<QueueUser>{
    val user:MutableList<QueueUser> = mutableListOf()

   beforeUser?.forEach {
       user.add(
           QueueUser(
               name = it.name, isYou = false, waitRange = null
           )
       )
   }
    if (currentUser != null){
        user.add(
            QueueUser(
                name = currentUser.name, isYou = true, waitRange = currentUser.waitingTime
            )
        )
    }
    return user
}